import { PropTypes } from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { fetchCoursesData } from '../../redux/slice/getCourses'
import axios from 'axios'
import { apis } from '../../api/apiUrl'

const CourseGenList = () => {
  const [searchParams] = useSearchParams()
  const dispatch = useDispatch()

  const state = useSelector(state => state.courses)
  const [query, setQuery] = useState({
    interest: -1,
    educationLevel: -1,
    educationResult: '',
    educationType: ''
  })


  useEffect(() => {
    setQuery({
      interest: searchParams.get('interest'),
      educationLevel: searchParams.get('educationLevel'),
      educationResult: searchParams.get('educationResult'),
      educationType: searchParams.get('educationType')
    })
  }, [searchParams])

  const courseList = state?.data?.courseDetails

  useEffect(() => {
    const isApiToFetch = () => {
      if (
        query.interest === null ||
        query.educationLevel === null ||
        query.educationResult === null ||
        query.educationType === null
      ) {
        return false
      }
      return true
    }

    if (isApiToFetch()) {
      dispatch(fetchCoursesData(query))
    }
  }, [dispatch, query])

  const saveCourse = ratingId => {
    try {
      axios.post(
        `${apis.uniten_api}/selectCourse`,
        {
          ratingId: ratingId
        }
      )
    } catch (error) {
      console.log(error)
    }
  }

  const handleClick = item => {
    console.log(item)
    saveCourse(item?.ratingId)
  }

  return (
    <div className='h-full   w-full p-4 flex flex-col items-start justify-between gap-8 border shadow-lg rounded-3xl lg:p-16'>
      <div className='flex flex-col gap-4'>
        <h1 className=' text-zinc-800 text-3xl font-bold f leading-9'>
          List of Courses
        </h1>
        <span className=' text-gray-600 text-base font-light  leading-snug'>
          These courses are suggestions for your next step.
        </span>
      </div>

      {/* show data in table with sorting */}
      <div className='w-full overflow-x-auto'>
        <div className='w-full border border-stone-300 '>
          <div className='text-left bg-[#edf7fa] px-2 border-stone-300'>
            <div className=' text-stone-500 flex items-center justify-between text-sm lg:text-lg font-medium'>
              <h1 className='px-4 py-3'>Course Name</h1>
              <h1 className='px-4 py-3'>Course Length</h1>
              <h1 className='px-4 py-3'></h1>
            </div>
          </div>
          <div className='divide-y divide-stone-300 '>
            {state.loading ? (
              <div className='flex items-center justify-center p-4'>
                <div className='w-8 h-8 border-4 border-gray-400 border-t-gray-700 rounded-full animate-spin transition-all'/>
              </div>
            ) : (
              courseList?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className='px-4 h-16 flex items-center justify-between'
                  >
                    <h1 className='px-4 py-3 flex-1'>{item.courseName}</h1>
                    <h1 className='px-4 py-3 flex-1 lg:ml-16'>
                      {item.duration}
                    </h1>
                    <button
                      type='button'
                      onClick={() => handleClick(item)}
                      className='px-4 py-3 text-blue-700 font-medium'
                    >
                      <span>Learn More</span>
                    </button>
                  </div>
                )
              })
            )}
          </div>
        </div>
      </div>

      {/* <button className=" px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 inline-flex" onClick={handleGoBack}>
                <div className="text-white text-base font-bold  capitalize whitespace-nowrap flex items-center gap-3">Generate Again <FiRepeat size={20} /></div>
            </button> */}
    </div>
  )
}
CourseGenList.propTypes = {
  handleGoBack: PropTypes.func
}
export default CourseGenList
